// extracted by mini-css-extract-plugin
export default {"text":"SettingsInfo_text__PvUy0","overflow":"SettingsInfo_overflow__AnI4Q","content":"SettingsInfo_content__A-IWs"};